<template>
    <div>
        <label>
            {{ title }}
            <span v-if="required" class="text-danger">*</span>
        </label>
        <div class="input-group mb-2">
            <input
                :type="type"
                :name="name"
                class="form-control"
                :id="refID"
                :placeholder="title"
                :value="value"
                @input="change($event.target.value)"
                :class="{
                    'is-invalid':
                        error,
                }"
                @keyup.enter="onEnter"
            />
            <div class="input-group-text">
                <a
                    href="javascript:void(0);"
                    @click="showHidePassword(refID)"
                >
                    <i
                        class="fa fa-eye"
                        aria-hidden="true"
                        style="color: #ff7534;"
                        v-if="isShowEyeButton"
                    ></i>
                    <i
                        class="fa fa-eye-slash"
                        aria-hidden="true"
                        style="color: #b9b9b9"
                        v-else
                    ></i>
                </a>
            </div>
            <div
                v-if="error"
                class="invalid-feedback"
            >
                {{ error }}
            </div>
        </div>
    </div>    
</template>


<script>
    export default {
        props: {
            title: String,
            name: String,
            value: String,
            error: String,
            type: String,
            required: Boolean,
            refID: {
                type: String,
                required: true
            },
            onEnter: {
                type: Function,
                default: () => 1
            }
        },
        data() {
            return {
                isShowEyeButton: false
            }
        },
        methods: {
            change(val) {
                this.$emit('input', val)
            },
            showHidePassword(idName) {
                let id = document.querySelector("#"+idName)
                if(id.type === 'password') {
                    id.type = 'text'
                    this.isShowEyeButton = true
                } else {
                    id.type = 'password'
                    this.isShowEyeButton = false
                }       
            },
        }
    }
</script>

